<style scoped>
::v-deep(.q-field__native) {
  text-align: center;
}

::v-deep(.q-select .q-field__input) {
  text-align: center;
}

::v-deep(.q-field--standout.q-field--highlighted .q-field__native) {
  text-align: center;
}

label {
  width: 220px;
}

::v-deep(.q-field__native) {
  font-size: 14px !important;
}
</style>
<style>
.unsub-btn {
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  border-radius: 10px;
  background: #ed885c;
  border: 1px solid #ed885c;
  padding: 10px 15px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  margin-top: 30px;
}

.unsub-btn:hover {
  background: transparent;
  color: #ed885c;
}

.error-find {
  text-align: center;
  color: #c10015;
  font-size: 12px;
}

.result-message {
  text-align: center;
}
</style>
<template>
  <div class="row column q-pa-md q-gutter-sm">
    <div v-if="!showResult" class="title">Введите ваш номер телефона</div>

    <!-- Обернули в форму -->
    <q-form v-if="!showResult" @submit.prevent="next" style="display: flex;flex-direction: column; align-items: center;" ref="form">
      <q-input
        :rules="phoneValidate"
        rounded
        standout
        ref="inputPhone"
        placeholder="Телефон"
        v-model="phone"
        mask="+7 (###) ###-####"
        @focus="handleFocus"
        @click="handleFocus"
      />
      <button class="unsub-btn q-mb-md" type="submit" :disabled="loading">
        {{ loading ? "Поиск..." : "ПОЛУЧИТЬ ВИТРИНУ" }}
      </button>
    </q-form>

    <!-- Результат после запроса -->
    <div v-if="showResult">
      <div style="text-align: center;" v-if="subscriptionsFound">
        <div class="result-message">
          Ваша витрина отправлена на адрес эл. почты {{ email }}
        </div>
      </div>

      <div style="text-align: center;" v-else>
        <div class="result-message">
          У Вас нет доступных витрин предложений. Вы можете заполнить заявку и получить персональные предложения.
        </div>
        <button class="unsub-btn q-mb-md" @click="handleRequest">
          Заполнить заявку
        </button>
      </div>
    </div>
  </div>
</template>







<script>
import * as Subscription from "@/assets/js/bid/subscription_iframe.js";
import * as Validate from "@/assets/js/validators.js";

export default {
  name: "BidShowcaseZaymelo",

  props: {
    forwardPage: Function,
  },

  data: () => ({
    phone: "",
    error: "",
    email: "",
    loading: false,
    showResult: false,
    subscriptionsFound: false,
  }),

  computed: {
    phoneValidate() {
      return [
        (val) => (val !== null && val !== "") || "Введите телефон",
        (val) => Validate.phone(val) || "Введите полностью",
      ];
    },
  },

  methods: {
    handleFocus() {
      if (!this.phone) {
        this.phone = "9";
      }
      this.$nextTick(() => {
        const input = this.$refs.inputPhone?.$el?.querySelector("input");
        if (input) {
          requestAnimationFrame(() => {
            input.setSelectionRange(input.value.length, input.value.length);
          });
        }
      });
    },

    async next() {
      // ✅ Проверяем валидацию через q-form
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      this.error = "";
      this.loading = true;
      this.showResult = false;

      try {
        const result = await Subscription.showcaseLink(this.phone);
        this.loading = false;

        if (result.error) {
          this.error = result.error;
          this.subscriptionsFound = false;
        } else if (result.success && result.email) {
          this.subscriptionsFound = true;
          this.email = result.email;
        } else {
          this.subscriptionsFound = false;
        }

      } catch (e) {
        this.error = "Произошла ошибка. Попробуйте позже.";
        this.subscriptionsFound = false;
        this.loading = false;
      }

      this.showResult = true;
    },

    handleRequest() {
      window.open("https://zaimelo.ru", "_blank");
    }
  },
};
</script>

